var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesclaimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3172_29898)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9974 15.3337C3.93073 15.3337 0.664062 12.067 0.664062 8.00033C0.664062 3.93366 3.93073 0.666992 7.9974 0.666992C12.0641 0.666992 15.3307 3.93366 15.3307 8.00033C15.3307 12.067 12.0641 15.3337 7.9974 15.3337ZM7.9974 2.00033C4.66406 2.00033 1.9974 4.66699 1.9974 8.00033C1.9974 11.3337 4.66406 14.0003 7.9974 14.0003C11.3307 14.0003 13.9974 11.3337 13.9974 8.00033C13.9974 4.66699 11.3307 2.00033 7.9974 2.00033Z",
    fill: "#E31F13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33594 5.33333V4H8.66927V5.33333H7.33594ZM7.33594 12V6.66667H8.66927V12H7.33594Z",
    fill: "#E31F13"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3172_29898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesclaimer);
export default __webpack_public_path__ + "static/media/desclaimer.26761631209a2ca7a7ddb4d49b906797.svg";
export { ForwardRef as ReactComponent };